import { Source } from '@/types';
import { FileText, Globe, ExternalLink } from 'lucide-react';
import { cn } from '@/lib/utils';
interface SourceCardProps {
  source: Source;
  onClick: (page?: number) => void;
}
export default function SourceCard({ source, onClick }: SourceCardProps) {
  const getIcon = () => {
    switch (source.type) {
      case 'pdf':
        return <FileText size={14} />;
      case 'web':
        return <Globe size={14} />;
      default:
        return <FileText size={14} />;
    }
  };
  const handleClick = () => {
    onClick(source.page);
  };
  return (
    <div
      onClick={handleClick}
      className={cn(
        'flex items-start gap-3 p-3 bg-gray-50 hover:bg-gray-100 rounded-lg border border-gray-200 cursor-pointer transition-colors text-sm',
        'group'
      )}
    >
      <div className="text-gray-500 mt-0.5 flex-shrink-0">{getIcon()}</div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="font-medium text-gray-900 truncate">
            {source.title}
          </span>
          {source.page && (
            <span className="text-xs bg-gray-200 text-gray-700 px-2 py-0.5 rounded-full">
              Page {source.page}
            </span>
          )}
          <ExternalLink
            size={12}
            className="text-gray-400 group-hover:text-gray-600 flex-shrink-0"
          />
        </div>
        {source.excerpt && (
          <p className="text-gray-600 text-xs mt-1 line-clamp-2">
            {source.excerpt}
          </p>
        )}
      </div>
    </div>
  );
}
